import script from "./PatientComments.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientComments.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./PatientComments.vue3.vue?vue&type=style&index=0&id=3424b0a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3424b0a4"]])

export default __exports__